import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ stage: "verifying", message: "" });
  const token = params.get("token") || "";

  useEffect(() => {
    if (!token) { setState({ stage: "error", message: "Kein Token in URL" }); return; }
    (async () => {
      try {
        await api.post("/customer-auth/verify-email", { token });
        setState({ stage: "ok", message: "" });
      } catch (e) {
        setState({ stage: "error", message: formatApiErrorDetail(e?.response?.data?.detail) || "Token ungültig" });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="verify-email-page">
      <div className="max-w-md text-center space-y-4">
        {state.stage === "verifying" && (
          <>
            <div className="text-5xl">⏳</div>
            <div className="text-xl font-bold">E-Mail wird bestätigt…</div>
          </>
        )}
        {state.stage === "ok" && (
          <>
            <div className="text-5xl">✅</div>
            <div className="text-2xl font-black uppercase" data-testid="verify-email-ok">E-Mail bestätigt</div>
            <div className="text-zinc-400">Du kannst dich jetzt anmelden.</div>
            <Link to="/login" className="inline-block text-cyan-400 hover:underline">Zum Login</Link>
          </>
        )}
        {state.stage === "error" && (
          <>
            <div className="text-5xl">⚠️</div>
            <div className="text-2xl font-black uppercase" data-testid="verify-email-error">Bestätigung fehlgeschlagen</div>
            <div className="text-zinc-400">{state.message}</div>
            <Link to="/login" className="inline-block text-cyan-400 hover:underline">Zum Login</Link>
          </>
        )}
      </div>
    </div>
  );
}
